// test1330
(1330 && 0);
